var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJwt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "21.906,31.772 24.507,29.048 27.107,31.772 27.107,43 21.906,43"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f50057",
    points: "17.737,29.058 21.442,28.383 21.945,32.115 15.345,41.199 11.138,38.141"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d500f9",
    points: "15.962,24.409 19.355,26.041 17.569,29.356 6.89,32.825 5.283,27.879"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29b6f6",
    points: "17.256,19.607 19.042,22.922 15.649,24.554 4.97,21.084 6.577,16.137"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00e5ff",
    points: "21.126,16.482 20.623,20.214 16.918,19.539 10.318,10.455 14.526,7.398"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "26.094,16.228 23.493,18.952 20.893,16.228 20.893,5 26.094,5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f50057",
    points: "30.262,18.943 26.558,19.618 26.055,15.886 32.654,6.802 36.862,9.859"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d500f9",
    points: "32.039,23.59 28.645,21.958 30.431,18.643 41.11,15.174 42.717,20.12"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29b6f6",
    points: "30.744,28.393 28.958,25.078 32.351,23.447 43.03,26.916 41.423,31.863"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00e5ff",
    points: "26.874,31.518 27.378,27.786 31.082,28.461 37.682,37.545 33.474,40.602"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwt);
export default __webpack_public_path__ + "static/media/jwt.8a766ec5b36b138a36c9f6b3957b4d1e.svg";
export { ForwardRef as ReactComponent };